import { render, staticRenderFns } from "./GestaoClienteProdutos.vue?vue&type=template&id=10483cd8"
import script from "./GestaoClienteProdutos.vue?vue&type=script&lang=js"
export * from "./GestaoClienteProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports